export default "/images/78de3a50b96744614f8c03c1086865da.avif";